/**
 * Simple file to include when switching over from large monolithic .js to the new react js injected components
 *
 * This currently exists, tested, in the helpcenter microsite frontend project
 * TODO: break out into its own npm package and import
 **/

(function(ebatesGlobal) {

    ebatesGlobal.helpcenter = ebatesGlobal.helpcenter || {};
    if (ebatesGlobal.helpcenter.legacy) {
        console.error('Attempting to load legacy-wrapper more than once.');
        return;
    }

    const revertMap = {};
    const defaultStub = () => null;

    const revertConstants = (wrapKey) => {
        const wrapObj = revertMap[wrapKey];
        if (wrapObj.legacyConstants) {
            // eslint-disable-next-line guard-for-in
            for (const key in wrapObj.legacyConstants) {
                wrapObj.instance[key] = wrapObj.legacyConstants[key];
            }
        }
        wrapObj.legacy = true;
    };

    /**
     * Reverts a namespaceFunction returned object to the previous legacy object
     * @param wrapKey
     */
    const revertToLegacy = (wrapKey) => {
        if (revertMap[wrapKey] && !revertMap.legacy) {
            revertConstants(wrapKey);
        }

        if (!revertMap[wrapKey]) {
            revertMap[wrapKey] = {
                legacy: true,
            };
        }
    };

    /**
     *
     * Note: this will run the function in line and assumes all legacy html elements are available on call
     *
     * @param namespaceFcn - A namespace producing function - intended to be called once and return a object with exposed
     *  functions/constants (constants are discouraged in favor of property-like setters)
     * @param wrapKey - This is a unique key to identify the reversion by
     * @param stubNamespace - A stubbed return object that will be returned unless reversion is performed
     * @param legacyIfNoStub - if true, this will use the legacy namespace fields if there is an undefined mirror in the stubNamespace object
     * @returns {(..args): {NamespaceObject}} Returns the new wrapped namespaceFcn
     */
    const withLegacyToggle = (namespaceFcn, wrapKey, stubNamespace, legacyIfNoStub) => (...args) => {
        // Effective Namespace - ideally should only hold functions
        const namespace = namespaceFcn(...args);

        // First check the revertMap to see if it's already at legacy
        const preExistingRevertEntry = revertMap[wrapKey];
        if (preExistingRevertEntry && preExistingRevertEntry.legacy) {
            return namespace;
        }

        const revertMapRecord = {
            legacy: false,
            legacyConstants: {},
        };
        if (namespace) {
            const newObject = {};
            for (const key in namespace) {
                if (Object.prototype.hasOwnProperty.call(namespace, key)) {
                    const namespaceField = namespace[key];
                    const stubField = stubNamespace[key];
                    if (legacyIfNoStub && stubField === undefined) {
                        newObject[key] = namespaceField;
                        continue;
                    }
                    if (typeof namespaceField === 'function') {
                        newObject[key] = (...fcnArgs) => {
                            if (revertMap[wrapKey].legacy) {
                                return namespaceField(...fcnArgs);
                            }
                            if (stubField) {
                                return stubField(...fcnArgs);
                            }
                            return legacyIfNoStub ? namespaceField(...fcnArgs) : defaultStub();
                        };
                        continue;
                    }
                    revertMapRecord.legacyConstants[key] = namespaceField;
                    newObject[key] = stubField;
                }
            }
            revertMapRecord.instance = newObject;
            revertMap[wrapKey] = revertMapRecord;
            return newObject;
        }

        // Set legacy to true since we can't set the reference to null
        revertMapRecord.legacy = true;
        revertMap[wrapKey] = revertMapRecord;
        console.warn('Legacywrapping null returned namespace object');
        return stubNamespace;
    };

    /**
     * Simple switching instantiation.  This is valuable if your code is not toggleable
     * (Either you have elements that are being removed or legacy code firing order that is complex)
     *
     * If the wrap key was given to the revert function previously, this will instantiate a new value
     * @param namespaceFnc
     * @param wrapKey
     * @param stubNamespace
     * @param args
     * @returns {*}
     */
    const asRevertOrStubNow = (namespaceFnc, wrapKey, stubNamespace, ...args) => {
        const revertMapValue = revertMap[wrapKey];
        if (revertMapValue && revertMapValue.legacy) {
            return namespaceFnc(...args);
        }
        return stubNamespace;
    };

    ebatesGlobal.helpcenter.legacy = {
        withLegacyToggle,
        revertToLegacy,
        asRevertOrStubNow,
    };
})(ebates);